import axios from "axios";
import React, { Suspense, useCallback, useEffect, useState } from "react";
import style from "css/menu.module.css";
import { Avatar, Checkbox, Tabs, Tree } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Input from "antd/es/input/Input";
import { useTranslation } from "react-i18next";
import Loading from "components/common/Loading";
import DeptTree from "components/common/tree/deptTree";

export default function ResParticipantSideBox({
  isOpenParticpantSideBox,
  closeParticipantSideBox,
  participantChange,
  treeMemberList,
  searchMemberList,
  recentMemberList,
  setTreeMemberList,
  setSearchMemberList,
  setRecentMemberList,
  schedule,
}) {
  const { t, i18n } = useTranslation();
  const [searchMemberValue, setSearchMemberValue] = useState("");

  const [checkboxTrigger, setCheckboxTrigger] = useState(false);
  //________________________________________________
  // tab1 (tree Member) ____________________________

  // tab2 (search Member) __________________________
  const handleSearchMember = (value) => {
    setSearchMemberValue(value);
    if (value) {
      searchMembers(value);
    } else {
      setSearchMemberList([]);
    }
  };
  // searched MemberList
  const searchMembers = (value) => {
    const url = "/user/searchList";
    // const url = "/address/searchList";
    const params = { KEY_WORD: value };
    axios
      .post(url, params)
      .then((res) => {
        if (res.status === 200) {
          let updatedMembers = [];

          res.data.map((member) => {
            const updatedMember = schedule.PARTICIPANT_LIST.find(
              (participant) => member.MEMBER_ID === participant.MEMBER_ID
            );
            if (updatedMember) {
              return updatedMembers.push({
                ...member,
                isChecked: !member.isChecked,
              });
            } else {
              return updatedMembers.push(member);
            }
          });
          setSearchMemberList(updatedMembers);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // checkbox status update
  const handleSearchMemberCheck = (member) => {
    setSearchMemberList(
      searchMemberList.map((m) =>
        m.MEMBER_ID === member.MEMBER_ID ? { ...m, isChecked: !m.isChecked } : m
      )
    );
    member.isChecked = !member.isChecked;

    participantChange(member);
  };

  // tab3 (recent Member) __________________________
  const recentMembers = () => {
    axios
      .get("/schedule/myParticipantList")
      .then((res) => {
        if (res.status === 200) {
          setRecentMemberList(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // checkbox status update
  const handleRecentMemberCheck = (member) => {
    setRecentMemberList(
      recentMemberList.map((m) =>
        m.MEMBER_ID === member.MEMBER_ID ? { ...m, isChecked: !m.isChecked } : m
      )
    );
    member.isChecked = !member.isChecked;

    participantChange(member);
  };

  const closed = () => {
    setRecentMemberList(
      recentMemberList.map((m) => (true ? { ...m, isChecked: false } : m))
    );
    setSearchMemberList(
      searchMemberList.map((m) => (true ? { ...m, isChecked: false } : m))
    );
  };

  useEffect(() => {
    if (!isOpenParticpantSideBox) {
      closed();
    }
    setReset(!reset);
  }, [isOpenParticpantSideBox]);

  const [groupList, setGroupList] = useState("");
  const organization = useCallback(() => {
    axios.get("/address/treeList").then((res) => {
      if (res.status === 200) {
        setGroupList(res.data);
      }
    });
  }, []);
  useEffect(() => {
    organization();
  }, [organization, isOpenParticpantSideBox]);

  const [reset, setReset] = useState(false);

  //________________________________________________

  const tabItems = [
    {
      key: "2",
      label: t("LABEL.CONTACT"),
      children: (
        <>
          <Input.Search
            value={searchMemberValue}
            onChange={(e) => handleSearchMember(e.target.value)}
          />
          <div className={style.res_popup_sideBox_searchList}>
            {searchMemberList.map((member) => (
              <ul
                key={member.MEMBER_ID}
                style={{
                  display: "flex",
                  alignItems: "center",
                  listStyleType: "none",
                  margin: 0,
                  marginBottom: "15px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  fontSize: "13px",
                  fontWeight: "normal",
                  color: "#333333",
                }}
              >
                <li style={{ display: "flex", marginRight: 10 }}>
                  <Checkbox
                    checked={member.isChecked}
                    onChange={() => handleSearchMemberCheck(member)}
                  />
                </li>
                <li style={{ display: "flex", marginRight: 10 }}>
                  <img
                    src={
                      process.env.REACT_APP_CLIENT_URL + "img/menu/avatar.png"
                    }
                    alt="avatar"
                  />
                </li>
                <li style={{ display: "flex", width: "33%" }}>
                  {member.DISPLAY_NM}
                </li>
                <li style={{ display: "flex", marginRight: 10, width: "60%" }}>
                  {member.EMAIL}
                </li>
              </ul>
            ))}
          </div>
        </>
      ),
    },
    {
      key: "1",
      label: t("LABEL.CHART"),
      children: (
        <DeptTree
          treeData={groupList}
          onUserSelect={(members) => {
            members.forEach((member) => handleSearchMemberCheck(member));
          }}
          resetTrigger={reset}
          defaultCheckedUsers={schedule.PARTICIPANT_LIST}
          checkBoxTrigger={checkboxTrigger}
        />
      ),
    },
    {
      key: "3",
      label: t("LABEL.RECENT"),
      children: (
        <div>
          {recentMemberList.map((member) => (
            <ul
              key={member.MEMBER_ID}
              style={{
                display: "flex",
                alignItems: "center",
                listStyleType: "none",
                margin: 0,
                padding: "5px 0px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: "15px",
                fontWeight: "normal",
                color: "#333333",
              }}
            >
              <li style={{ marginRight: 10 }}>
                <Checkbox
                  checked={member.isChecked}
                  onChange={() => handleRecentMemberCheck(member)}
                />
              </li>
              <li style={{ marginRight: 10 }}>
                <Avatar size="small" icon={<UserOutlined />} />
              </li>
              <li style={{ marginRight: 10, width: "60%" }}>{member.EMAIL}</li>
              <li style={{ width: "30%" }}>{member.DISPLAY_NM}</li>
            </ul>
          ))}
        </div>
      ),
    },
  ];

  const tabsChange = (num) => {
    if (num === "1") {
    } else if (num === "2") {
    } else {
      recentMembers();
    }
    setReset(!reset);
  };

  useEffect(() => {
    setCheckboxTrigger(!checkboxTrigger);
  }, [schedule.PARTICIPANT_LIST]);

  return (
    <div
      className={`${style.res_popup_sideBox} ${
        isOpenParticpantSideBox ? style.expanded : ""
      }`}
    >
      <div className={style.res_popup_sideBox_container}>
        <div className={style.res_popup_sideBox_container_header}>
          <div className={style.res_popup_sideBox_recycleIcon_bg}>
            <img
              className={`${style.res_popup_sideBox_recycleIcon} ${
                isOpenParticpantSideBox ? style.expanded : ""
              }`}
              src={process.env.REACT_APP_CLIENT_URL + "img/menu/sync.png"}
              alt="sync"
            />
          </div>
          <div className={style.sideBox_titleArea}>
            <span>{t("LABEL.TITLE.CONTACT_INFO")}</span>
            <img
              className={style.res_popup_sideBox_closeBtn}
              src={process.env.REACT_APP_CLIENT_URL + "img/menu/close.png"}
              alt="close"
              onClick={closeParticipantSideBox}
            />
          </div>
          <div className={style.sideBox_tabsArea}>
            <Tabs
              defaultActiveKey="2"
              items={tabItems}
              size="middle"
              style={{
                color: "#999999",
                justifyContent: "center",
                width: "100%",
              }}
              tabBarGutter={i18n.language === "en-US" ? 23 : 42}
              onChange={tabsChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
